import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';

/**
 * @param {string} stockCode
 */
function useDtTradeable(stockCode) {
  const { cb, key } = fetch(stockCode);
  const { data, isSuccess, refetch } = useQuery(key, cb, {
    enabled: !!stockCode,
    staleTime: Infinity,
  });

  const isTradeable = data?.status_odt === 'ENABLED';
  const isUntradeable = data?.status_odt !== 'ENABLED';

  return { data, isSuccess, refetch, isTradeable, isUntradeable };
}

export default {
  useDtTradeable,
};
